import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {
  AnchorButton,
  Icon,
  Position
} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Popover2} from '@blueprintjs/popover2'

import {getBlockSelector} from '../../../../store/reducers/blockReducer';
import {ExportType} from './constants';
import Options from './Options';
import {getExportOptionsFromBlock, getNameFromExportOptions} from './utils';

import './ExportOptions.scss';

interface ExportButtonProps {
  show: boolean;
  contentId: string;
  csv?: boolean;
  xlsx?: boolean;
  html_table?: boolean;
  png?: boolean;
  onChange: (key: string, value: any) => void;
  disabled?: boolean;
}

export const ExportButton = React.memo(({
  show,
  contentId,
  csv = false,
  xlsx = false,
  html_table = false,
  png = false,
  onChange,
  disabled = false,
}: ExportButtonProps) => {
  const block = useSelector(getBlockSelector(contentId));
  const blockName = block?.name as string;
  const exportOptions = getExportOptionsFromBlock(block);
  const name = getNameFromExportOptions(exportOptions, block?.name as string);

  const [type, setType] = useState<ExportType | null>(exportOptions?.type as ExportType || null);

  const onOptionChange = (key: string) => (value: any) => {
    onChange(key, value);
  }

  if (!show) {
    return null;
  }

  return (
    <div className="export-options">
      <Icon icon={IconNames.NEST}/>
      <Popover2
        content={
          <Options
            csv={csv}
            xlsx={xlsx}
            html_table={html_table}
            png={png}
            blockName={blockName}
            selected={type}
            setSelected={setType}
            exportOptions={exportOptions}
            onChange={onOptionChange}
          />
        }
        position={Position.BOTTOM_RIGHT}
      >
        <AnchorButton
          small={true}
          text={name}
          icon={IconNames.PAPERCLIP}
          rightIcon={IconNames.COG}
          disabled={disabled}
        />
      </Popover2>
    </div>
  );
});
